<template>
  <div
    v-if="articles?.length"
    data-testid="related-articles-section"
    class="rounded-lg border border-primary-300 bg-primary-100 p-4"
  >
    <h4
      class="text-sm font-medium text-primary-800 mb-3 flex items-center gap-2"
    >
      <svg
        class="h-4 w-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
        ></path>
      </svg>
      {{ t('articles.related') }}
    </h4>
    <ul class="space-y-3">
      <li
        v-for="article in articles"
        :key="article.title"
        class="text-sm text-primary-800 border border-neutral-200 rounded-lg p-3 bg-white"
      >
        <div class="space-y-1">
          <h5 class="font-medium text-primary-800">
            {{ article.title }}
          </h5>
          <div
            class="text-neutral-700 markdown-content"
            v-html="renderMarkdown(article.summary)"
          ></div>
          <a
            v-if="article.link"
            :href="article.link"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center gap-1 text-primary-500 hover:text-primary-800 underline text-xs"
          >
            {{ t('articles.viewArticle') }}
            <svg
              class="h-3 w-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              ></path>
            </svg>
          </a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { AdditionalInfo } from '@/types';
import { renderMarkdown } from '@/utils/markdown';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

interface Props {
  articles?: AdditionalInfo['related_articles'];
}

defineProps<Props>();
</script>
